<script>
  // Перенос Bullet из parts.tsx — пункт перечисления (состав набора).
  import Ico from '../ico.svelte';
</script>

<div class="mn-bul"><Ico n="check" s={15} /><span><slot /></span></div>
